import { motion } from "framer-motion";

const lineVariants = {
  hidden: { y: "110%", rotate: 2 },
  show: (i) => ({
    y: 0,
    rotate: 0,
    transition: { duration: 0.9, delay: 0.15 + i * 0.12, ease: [0.2, 0.8, 0.2, 1] },
  }),
};

export const RevealLines = ({ lines, className = "", testId }) => (
  <h1 data-testid={testId} className={className}>
    {lines.map((line, i) => (
      <span key={i} className="kp-reveal-line">
        <motion.span className="block" custom={i} variants={lineVariants} initial="hidden" animate="show">
          {line}
        </motion.span>
      </span>
    ))}
  </h1>
);

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.2, 0.8, 0.2, 1] }}
  >
    {children}
  </motion.div>
);
